import React from "react";
import { Weight } from "lucide-react";
import { num } from "@/lib/format";

// Badge peso complessivo (kg) di un documento; `parziale` = alcune righe senza peso unitario
export function PesoBadge({ peso, parziale, testid, className = "" }) {
  if (peso == null) return null;
  return (
    <span className={`inline-flex items-center gap-1 rounded-full border border-slate-200 bg-slate-50 px-2 py-0.5 text-xs font-mono text-slate-700 ${className}`} title={parziale ? "Peso calcolato solo sugli articoli con peso unitario impostato" : "Peso complessivo (peso unitario × quantità)"} data-testid={testid}>
      <Weight className="h-3 w-3 text-slate-400" /> {num(peso, 1)} kg{parziale && <span className="text-amber-600">*</span>}
    </span>
  );
}
